import numeral from "numeral";

const currencyText = (currency, value, locale, digit) => {
  let splitLocale = `${locale.split("-")[0]}`;

  if (splitLocale !== "en") {
    try {
      require(`numeral/locales/${splitLocale}`);
    } catch (e) {
      splitLocale = "en";
      // silent ignore, keep en
    }
  }

  numeral.locale(splitLocale);
  const format = digit !== undefined ? `0,0.` + "0".repeat(digit) : `0,0.00`;

  return !currency
    ? numeral(value).format(format)
    : `${numeral(value).format(format)} ${currency.symbol}`;
};

export default currencyText;
